class ProductForm extends HTMLElement {
  constructor() {
    super();   

    this.form = this.querySelector('form');
    this.quantity = this.querySelector('input[type="number"]');
    this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
  }

  onSubmitHandler(evt) {
    evt.preventDefault();
    
    const submitButton = this.querySelector('[type="submit"]');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('ajax-loader-btn');

    const body = JSON.stringify({
      ...JSON.parse(serializeForm(this.form)),
      sections_url: window.location.pathname
    });

    this.addCart(body, submitButton)
  }

  addCart(body, button) {
    var form = document.querySelector('[id^="product-form-template"]');
    var formdata = false;
      if(window.FormData){
        formdata = new FormData(form)
      }

      var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: formdata,
        processData: false,
        contentType: false,
        dataType: 'json',
        success: function(lineitem){
          document.querySelector(button.getAttribute('data-modal'))?.show(lineitem, button, this.quantity?.value < 0 ? 1 : this.quantity?.value );
          button?.classList.remove('ajax-loader-btn');
          button?.removeAttribute('disabled');
        },
        error: function(e) {
        console.error(e);
        }
};
      jQuery.ajax(params);

    
    
// fetch(`${routes.cart_add_url}`, { ...fetchConfig('javascript'), body })
//       .then((response) => response.json())
//       .then((lineitem) => {
//         if (lineitem.status != 422) {
//           document.querySelector(button.getAttribute('data-modal'))?.show(lineitem, button, this.quantity?.value < 0 ? 1 : this.quantity?.value );
//         }
//       })
//       .catch((e) => {
//         console.error(e);
//       })
//       .finally(() => {
//         button?.classList.remove('ajax-loader-btn');
//         button?.removeAttribute('disabled');
//       });
  }

}

customElements.define('product-form', ProductForm);

class ProductTabMenu extends HTMLElement {
  constructor() {
    super();
    this.querySelectorAll(".tab-title").forEach((tab) => tab.addEventListener('click', this.toggleActive.bind(this)));
  }

  toggleActive() {
    event.preventDefault();
    this.querySelectorAll(".tab-title").forEach((tab) => tab.classList.remove('active'));
    var href = event.target.getAttribute("href");
    event.target.parentNode.classList.add("active")
    document.querySelectorAll(".tab-content").forEach((tab) => tab.classList.remove('active'));
    if(document.getElementById(href.replace("#",""))) {
      document.getElementById(href.replace("#","")).classList.add("active")
    }
  }
}
customElements.define("tab-menu", ProductTabMenu)



